export default __webpack_public_path__ + "static/media/news1.ecc640e7.png";